import service from './index'

const resource = service.resource('races{/id}')
const resourceRaceTypes = service.resource('races/race-types-list')
const resourceDelete = service.resource('races{/id}/remove')
const resourceUpdateLiveStatus = service.resource('races{/idRace}/notify-race-is-live')
const resourceFinalresult = service.resource('races/final-results/{raceId}')
const resourceTypeAvailable = service.resource('races/types-available')
const resourceBonusToRunner = service.resource('races/add-bonus-to-runner/{raceId}/{runnerId}')

export default {
  get (id) {
    return resource.get({id: id})
  },
  getTypes(){
    return resourceRaceTypes.get()
  },
  getFinalresults(id) {
    return resourceFinalresult.get({raceId: id})
  },

  createOne (race) {
    return resource.save({}, race)
  },
  deleteOne (race) {
    // Handle both race object or direct ID parameter
    const raceId = typeof race === 'object' ? race.id : race
    return resourceDelete.delete({id: raceId})
  },
  updateOne (race) {
    // Ensure race has an id property before updating
    if (!race || (!race.id && typeof race !== 'string')) {
      console.error('Invalid race object or ID provided to updateOne')
      return Promise.reject(new Error('Invalid race data'))
    }
    return resource.update(race)
  },
  updateStatusLive(id){
    return resourceUpdateLiveStatus.save({idRace: id}, {})
  },
  getRaceTypeAvailable(){
    return resourceTypeAvailable.get()
  },
  updateBonusdistance(raceId,runnerId,data){
    return resourceBonusToRunner.save({raceId: raceId,runnerId:runnerId}, data)
  }


}




// WEBPACK FOOTER //
// ./src/services/races.js